// extracted by mini-css-extract-plugin
export var button = "_n9-2";
export var card = "_n9-0";
export var closeButtonContainer = "_n9-3";
export var iconContainer = "_n9-1";